"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const native_base_1 = require("native-base");
const theme_1 = require("theme");
const services_1 = require("services");
const icons_1 = __importDefault(require("constants/icons"));
const native_1 = require("@react-navigation/native");
const ModalSelectPromotionReasonCompany = ({ onSelectedPromotionReason, ...rest }) => {
    const navigation = (0, native_1.useNavigation)();
    const [promotionReasons, setPromotionReasons] = React.useState();
    const listPromotionReasons = async () => {
        const onSuccess = (response) => {
            setPromotionReasons(response?.data);
            if ((response?.data?.length ?? 0) == 1)
                setRadioValue(response?.data?.[0]?.nombre);
        };
        (0, services_1.doPromotionReasonList)({
            params: {
                data: {},
            },
            callback: {
                onSuccess,
            },
        });
    };
    (0, native_1.useFocusEffect)(React.useCallback(() => {
        listPromotionReasons();
        return () => {
            setPromotionReasons(undefined);
        };
    }, []));
    const [radioValue, setRadioValue] = React.useState(null);
    const onConfirmPress = () => {
        const promotionReasonSelected = promotionReasons?.find(element => {
            return element.nombre === radioValue;
        });
        onSelectedPromotionReason(promotionReasonSelected);
    };
    const renderItem = ({ item }) => (<native_base_1.Pressable onPress={() => {
            setRadioValue(item.nombre);
        }} mt="10" borderWidth={1} borderColor="colorLightGray1" borderRadius={theme_1.Sizes.configRadius} flexDirection="row" alignItems="center">
				<native_base_1.Image source={icons_1.default.icTruck} ml="15" w="15" h="15"/>
				<native_base_1.Text py={10} flex="1" mx="10" variant="body4">
					{item.nombre || ""}
				</native_base_1.Text>
				<native_base_1.Radio value={item?.nombre ?? ""} mr="15"></native_base_1.Radio>
			</native_base_1.Pressable>);
    return (<native_base_1.Modal {...rest}>
				<native_base_1.Modal.Content>
					<native_base_1.Modal.CloseButton />
					<native_base_1.Modal.Header>{theme_1.Str.promotionReason}</native_base_1.Modal.Header>
					<native_base_1.Modal.Body>
						<native_base_1.Radio.Group name="options" value={radioValue} onChange={newValue => {
            setRadioValue(newValue);
        }}>
							<native_base_1.FlatList data={promotionReasons} renderItem={renderItem} key={radioValue?.direccion} extraData={radioValue?.direccion} w="100%"/>
						</native_base_1.Radio.Group>
					</native_base_1.Modal.Body>
					<native_base_1.Modal.Footer>
						<native_base_1.Button flex={1} onPress={onConfirmPress}>
							{theme_1.Str.confirm}
						</native_base_1.Button>
					</native_base_1.Modal.Footer>
				</native_base_1.Modal.Content>
			</native_base_1.Modal>);
};
exports.default = ModalSelectPromotionReasonCompany;
